import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

function Users() {
  const navigate = useNavigate();

  return (
    <Result
      status="success"
      title="Se abrió una nueva pestaña con los usuarios en el administrador"
      extra={[
        <Button type="primary" onClick={() => navigate("/")}>
          Ir al inicio
        </Button>,
      ]}
    />
  );
}

export default Users;
